import qwest from 'qwest';
import SuggestedProducts from '../models/suggestedProduct.jsx';

export function getSuggestedProducts() {
  return qwest.get('/SuggestedProduct')
    .then((xhr, res) => {
      if (res.success) {
        return res.data.map(e => SuggestedProducts.fromApiFormat(e));
      }
      return null;
    })
    .catch(err => {
      console.error(err);
    });
}

export function saveSuggestedProducts(list) {
  return qwest.post('/SuggestedProduct', list)
    .then((xhr, res) => {
      if (res.success) {
        return res.data;
      }
      return res;
    })
    .catch(err => {
      console.error(err);
    });
}

export function deleteSuggestedProducts() {
  return qwest.delete('/SuggestedProduct/Delete')
    .then((xhr, res) => {
      if (res.success) {
        return res.data;
      }
      return res;
    })
    .catch(err => {
      console.error(err);
    });
}
